<div class="copo-container">
	<div class="copo-section">
		<div class="copo-section-header">
			<span translate>fastlane.wizard.header.request.data</span>
		</div>
	</div>
	<div class="copo-section-body copo-grid">
		<div class="copo-grid-row">
			<div class="copo-grid-row-column width-content" *ngIf="form.getFormCustomerRequestName().value">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.wizard.header.customer-request-name</div>
					<div class="card-content-value width-content"
						[matTooltip]="form.getFormCustomerRequestName().value ?getTooltipDescriptionText(form.getFormCustomerRequestName().value) : UNDERSCORE">
						{{ requestName ? requestName : UNDERSCORE }}</div>
				</div>
			</div>
			<div class="copo-grid-row-column width-content">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.wizard.soldto.name</div>
					<div class="card-content-value width-content" [matTooltip]="soldto ? soldto : UNDERSCORE">
						{{ soldto ? soldto : UNDERSCORE }} </div>
				</div>
			</div>
			<div class="copo-grid-row-column width-content" *ngIf="form.getFormDescription().value">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.wizard.header.global.description</div>
					<div class="card-content-value width-content" matTooltipClass="multiline-tooltip"
						[matTooltip]="form.getFormDescription().value ? getTooltipDescriptionText(form.getFormDescription().value): UNDERSCORE">
						{{ description }}</div>
				</div>
			</div>
			<div class="copo-grid-row-column width-content" *ngIf="!form.getFormDescription().value">
			</div>
		</div>
	</div>
	<div class="copo-section-body copo-grid">
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.wizard.shipto.name</div>
					<div class="card-content-value" [matTooltip]="shipto ? shipto : UNDERSCORE">
						{{ shipto ? shipto : UNDERSCORE }}
					</div>
				</div>
			</div>
			<div *ngIf="customDestination" class="copo-grid-row-column width-content">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.wizard.custom.destination</div>
					<div class="card-content-value width-content" matTooltipClass="multiline-tooltip" [matTooltip]="getCustomShipToTooltipText()">
						{{ customDestination }}
					</div>
				</div>
			</div>
			<div *ngIf="!customDestination" class="copo-grid-row-column width-content">
			</div>
			<div class="copo-grid-row-column">
				<div class="copo-attachment-block">
					<div *ngIf="hasRequestAttachments()" class="card-content-label" translate>
						claim.attachments</div>
					<div class="card-content-value" *ngFor="let attachment of getRequestAttachments();">
						<a class="attachment-link" [href]="attachment.localUrl | copoSafeUrl" target="_blank">{{attachment.fileName}}</a></div>
				</div>
			</div>
		</div>
	</div>
	<div class="copo-section-body copo-grid">
		<div class="copo-grid-row">
			<div class="copo-grid-row-column" *ngIf="form.getFormCurrency().value">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.wizard.currency</div>
					<div class="card-content-value"
						[matTooltip]="form.getFormCurrency().value ? form.getFormCurrency().value : UNDERSCORE">
						{{ form.getFormCurrency().value ? form.getFormCurrency().value : UNDERSCORE }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="copo-container fastlane-grey-block line-space ">
	<div class="copo-section">
		<div class=" copo-section-header">
			<div class="card-header-left">
				<div class="card-title-label">
					<span translate>fastlane.wizard.items.details.itemrequest</span>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="copo-container fastlane-product-block">
	<div class="copo-section">
		<form [formGroup]="productFormGroup" novalidate autocomplete="off">
			<div class="grid-column-one-full card-block">
				<div formArrayName="productSpecifications">
					<div class="card-product-block" *ngFor="let itemrow of productResultControl; let i=index"
						[formGroupName]="i" #rows>
						<div
							[ngClass]="(isSheetSelected(i))?'card-header column-9 copo-dark-theme copo-dark-theme-padding':'card-header column-8 copo-dark-theme copo-dark-theme-padding'">
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									need4steel.wizard.stepper.product.itemnumber</div>
								<div class="card-header-label field-width">{{ i+1 | number: '3.' }}</div>
							</div>
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.product.item_name</div>
								<div class="card-header-label field-width width-content"
									[matTooltip]="getTooltipDescriptionText(getItemName(i))">
									{{getItemName(i)}}</div>
							</div>
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width " translate>
									fastlane.itemlist.product.steel_grade</div>
								<div class="card-header-label field-width width-content"
									[matTooltip]="getTooltipDescriptionText(getSteelGrade(i))">
									{{getSteelGrade(i)}}</div>
							</div>
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.product.item_form</div>
								<div class="card-header-label field-width" [matTooltip]="getOrderTrackingForm(i)">
									{{getOrderTrackingForm(i)}}</div>
							</div>
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.order.thickness</div>
								<div class="card-header-label field-width" [matTooltip]="getThickness(i)">
									{{getThickness(i)}}</div>
							</div>
							<div *ngIf="getOrderTrackingForm(i)!=='Form Blank' else formblank"
								class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									order.width</div>
								<div class="card-header-label field-width" [matTooltip]="getWidth(i)">{{getWidth(i)}}
								</div>
							</div>
							<ng-template #formblank>
								<div class="card-container-column step-product-spec-field field-padding">
									<div class="card-header-label field-width" translate>
										fastlane.itemlist.product.blank_weight</div>
									<div class="card-header-label field-width" [matTooltip]="getFormBlank(i)">
										{{getFormBlank(i)}}</div>
								</div>

							</ng-template>

							<div *ngIf="getOrderTrackingForm(i)==='Sheet'"
								class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									batch.length</div>
								<div class="card-header-label field-width" [matTooltip]="getLength(i)">{{getLength(i)}}
								</div>
							</div>
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.global.quantity</div>
								<div class="card-header-label field-width" [matTooltip]="getQuantity(i)">
									{{getQuantity(i)}}</div>
							</div>
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.global.unit</div>
								<div class="card-header-label field-width" [matTooltip]="getUnit(i)">{{getUnit(i)}}
								</div>
							</div>
						</div>
						<mat-expansion-panel class="product-section" [expanded]="true"> 
							<ng-template matExpansionPanelContent>
								<div class="copo-grid-row">
									<div class="card-content-left column-6">

										<mat-form-field
											class="copo-content-product card-header-double-span  copo-form-field label-padding" floatLabel="always"
											(click)="$event.stopPropagation()">
											<mat-label class="card-content-label-1"
												translate>fastlane.wizard.items.details.datetype</mat-label>
											<mat-select formControlName="rddType" required
												(selectionChange)="onSelectChange(i)" [compareWith]="compareWithFn">
												<mat-option *ngFor="let rdd of getRdd()" [value]="rdd.code"
													[matTooltip]="rdd.value  | translate">
													<span>{{ rdd.value  | translate}}</span>
												</mat-option>
											</mat-select>
											<mat-error class="wrap-error"
												[matTooltip]="('fastlane.wizard.items.details.datetype.errormsg' | translate)">
												<span translate>fastlane.wizard.items.details.datetype.errormsg</span>
											</mat-error>
										</mat-form-field>
										<!-- RDD Date -->
										<mat-form-field *ngIf="getRddType(i) === '2'"
											class=" copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()"
											floatLabel="always">
											<mat-label class="card-content-label-1"
												translate>fastlane.wizard.items.details.datetype.rdd</mat-label>
											<input matInput spellcheck="false" autocomplete="off" readonly
												[copoDatepicker]="startDatepicker" copoFormat="week"
												[min]="calStartDate" [max]="calEndDate" (click)="startDatepicker.open()"
												#startDateInput (focus)="startDateInput.blur()" formControlName="rddDate">
											<mat-datepicker-toggle matSuffix class=" cal-icon-color "
												[for]="startDatepicker"></mat-datepicker-toggle>
											<mat-datepicker #startDatepicker></mat-datepicker>
										</mat-form-field>
										<mat-form-field *ngIf="getRddType(i) === '1'"
											class="mat-form-field-wrapper copo-content-product card-header-double-span copo-form-field label-padding" floatLabel="always"
											(click)="$event.stopPropagation()">
											<mat-label class="card-content-label-1"
												translate>fastlane.wizard.items.details.datetype.rdd</mat-label>
											<input matInput autocomplete="off" readonly spellcheck="false"
												[copoDatepicker]="picker" copoFormat="date" [min]="calStartDate"
												[max]="calEndDate" (click)="picker.open()" #startDateInput2
												(focus)="startDateInput2.blur()"  formControlName="rddDate">
											<mat-datepicker-toggle class=" cal-icon-color" matSuffix
												[for]="picker"></mat-datepicker-toggle>
											<mat-datepicker #picker></mat-datepicker>
										</mat-form-field>

										<mat-form-field
											class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()"
											floatLabel="always">
											<mat-label class="card-content-label-1"
												translate>transport.mode</mat-label>
											<mat-select formControlName="transportMode"
												required>
												<mat-option [value]="transportModeInitselected">
													<span translate>fastlane.itemlist.product.coil_axis.default</span>
												</mat-option>
												<mat-option *ngFor="let transportMode of getTransportMode()| copoSortOptions:true: config"
													[value]="transportMode.value"
													[matTooltip]="transportMode.display">
													{{ transportMode.display }}
												</mat-option>
											</mat-select>
											<mat-error class="wrap-error"
												[matTooltip]="('fastlane.wizard.product.transport.mode.errormsg' | translate)">
												<span translate>fastlane.wizard.product.transport.mode.errormsg</span>
											</mat-error>
										</mat-form-field>
										<mat-form-field
											class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()"
											floatLabel="always">
											<mat-label class="card-content-label-1" translate>eoffer.incoterms</mat-label>
											<mat-select formControlName="incoterms" required>
												<mat-option [value]="incotermInitselected" >
													<span translate>fastlane.itemlist.product.coil_axis.default</span>
												</mat-option>
												<mat-option *ngFor="let incot of incotList|copoSortOptions:false:configForIncotList" [value]="incot.code" [matTooltip]="incot.code">
													{{incot.code}}
												</mat-option>
											</mat-select>
											<mat-error class="wrap-error"
												[matTooltip]="('eoffer.mandatory.incot.reference' | translate)">
												<span translate>eoffer.mandatory.incot.reference</span>
											</mat-error>
										</mat-form-field>
										<mat-form-field
											class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()"
											floatLabel="always">
											<mat-label class="card-content-label-1" translate>order.packing</mat-label>
											<input matInput type="text" maxlength="50"
												class="input-field-text field-width"
												(keydown.space)="$event.preventDefault();" formControlName="packing">
											<mat-icon class="pencil-icon " svgIcon="copo_pencil"
												matSuffix></mat-icon>
										</mat-form-field>
										<mat-form-field
											class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()">
											<mat-label class="card-content-label-1"
												translate>fastlane.wizard.product.transport.desired.arcelormittal.plant</mat-label>
											<mat-select formControlName="plant"
												required>
												<mat-option *ngFor="let plant of getPlant()|copoSortOptions:false:configForPlant" [value]="plant.code"
													[matTooltip]="plant.value">
													<span *ngIf="plant.value === '-- None --' else notranslation" translate>fastlane.itemlist.product.coil_axis.default</span>
														<ng-template #notranslation>{{ plant.value}}</ng-template>
												</mat-option>
											</mat-select>
											<mat-error class="wrap-error"
												[matTooltip]="('fastlane.wizard.product.transport.desired.arcelormittal.plant.errmsg' | translate)">
												<span
													translate>fastlane.wizard.product.transport.desired.arcelormittal.plant.errmsg</span>
											</mat-error>
										</mat-form-field>
									</div>
								</div>
								<!--delivery address-->	
								<div class="copo-stepper-container copo-form-container">
									<div class="copo-grid-row-ship-to-block">
											<div class="copo-grid-row-column">
												<!-- ShipTo -->
												<mat-form-field class="copo-form-field">
													<mat-label translate>fastlane.wizard.delivery.address</mat-label>
													<mat-select formControlName="shipTo" required (selectionChange)="onChangeShipTo(i)" #shipToField>
														<mat-option value="LATER"
															[matTooltip]="'fastlane.wizard.decide.later' | translate">
															<div class="copo-fastlane-ship-to-name" translate>fastlane.wizard.decide.later</div>
														</mat-option>
														<mat-option value="CUSTOM"
															[matTooltip]="'fastlane.wizard.custom.destination' | translate">
															<div class="copo-fastlane-ship-to-name" translate>fastlane.wizard.custom.destination</div>
														</mat-option>
														<mat-option *ngFor="let shipTo of shipToList|copoSortOptions:false:configForBoc" [value]="shipTo.businessId">
															<div class="copo-fastlane-ship-to-name" [matTooltip]="shipTo.name +' / '+ shipTo.city">{{shipTo.name}}&nbsp;/&nbsp;{{shipTo.city}}</div>
															<div class="copo-fastlane-ship-to-address" *ngIf="shipToField.panelOpen" [matTooltip]="shipTo.address +' '+ (shipTo.postalCode ? shipTo.postalCode : '') + ' ' + shipTo.city + ' (' + shipTo.country + ')'">
																{{shipTo.address}} {{shipTo.postalCode}} {{shipTo.city}} ({{shipTo.country}})
															</div>
														</mat-option>
													</mat-select>
													<mat-error *ngIf="form.getFormShipTo().hasError('required')">
														<span translate>fastlane.delivery.address</span>
													</mat-error>
												</mat-form-field>
											</div>
											<div *ngIf="getShipToType(i) === 'CUSTOM'" class="copo-grid-row-column box">
												<span class="card-content-label-custom" translate>fastlane.wizard.custom.destination</span>
												<div class="copo-grid-row-custom">
													<mat-form-field class="copo-grid-row-column-ship-to-block copo-form-field">
														<mat-label translate>fastlane.wizard.shipto.name</mat-label>
														<input
														type="text"
														matInput
														spellcheck="false"
														autocomplete="off"
														maxlength="150"
														required
														formControlName="shipToCustom">
														<mat-icon color="accent" class="icon-size" svgIcon="copo_pencil" matSuffix>
														</mat-icon>
														<mat-error *ngIf="form.getFormShipToCustom().hasError('required')">
															<span translate>fastlane.delivery.address</span>
														</mat-error>
													</mat-form-field>
													<mat-form-field class="copo-grid-row-column-ship-to-block copo-form-field">
														<mat-label translate>fastlane.wizard.custom.destination.contact.person</mat-label>
														<input
														type="text"
														matInput
														spellcheck="false"
														autocomplete="off"
														maxlength="50"
														required
														formControlName="shipToPerson">
														<mat-icon color="accent" class="icon-size" svgIcon="copo_pencil" matSuffix>
														</mat-icon>
														<mat-error *ngIf="form.getFormShipToPerson().hasError('required')">
															<span translate>fastlane.wizard.contact.person.mandatory</span>
														</mat-error>
													</mat-form-field>
												</div>
												<div class="copo-grid-row-custom">
													<div class="copo-grid-row-column-empty"></div>
													<mat-form-field class="copo-grid-row-column-ship-to-block copo-form-field">
														<mat-label translate>fastlane.wizard.contact.phone.number</mat-label>
														<input
														type="text"
														matInput
														spellcheck="false"
														autocomplete="off"
														maxlength="50"
														required
														formControlName="shipToContact">
														<mat-icon color="accent" class="icon-size" svgIcon="copo_pencil" matSuffix>
														</mat-icon>
														<mat-error *ngIf="form.getFormShipToContact().hasError('required')">
															<span translate>fastlane.wizard.phone.number.mandatory</span>
														</mat-error>
													</mat-form-field>
												</div>
											</div>
										</div>
									</div>
							</ng-template>
						</mat-expansion-panel>
						<mat-divider class="mat-divider"></mat-divider>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>